	export enum PurposeOfVisitEnum {
		AE = 1,
		HAE = 2,
		Annual = 3,
		Pediatric = 4
	}
